import React from "react"
import "../styles/scss/blog.module.scss";
import parse from "html-react-parser"

import Link from "next/link";
import dayjs from "dayjs";
import Layout from "../components/layout";
import CallToActionSmall from "../components/v2/call-to-action-sm";

const BlogArchive = ({allPostData,uri,nextPagePath,prevPagePath,currentPage,totalPosts,postPerPage } ) => {
    const totalPages = Math.ceil(totalPosts / postPerPage);
    const posts = allPostData.edges || [];
    const offset = postPerPage * (currentPage - 1);
    const postArchieve = posts.slice(offset, offset + postPerPage);

    return (
        <Layout ogImage={null}  isHomePage={false} pageTitle={"Blog"}
                 uri={uri}
                 metaTitle={"Observability News, and Best Practices and Guides"}
                 metaDesc={"Read how observability can scale your cloud infrastructure, best practices, how-tos guide and industry updates from experts."}
                 metaRobotsNoindex={"index"}
                 metaRobotsNofollow={"follow"}
        >
            <div className={'middle-wrapper site-page all-blogs-v2'}>
                    <div className={'container'}>
                        <div className={'content-container'}>
                            <div className={'content-wrapper'}>
                                <div className={'d-flex'}>
                                    {postArchieve.map(__post => {
                                        const post = __post.node
                                        const title = post.title
                                        return <div className={'inner-block'} key={post.uri}>
                                            <Link href={`/blog/${post.slug}`} itemProp="url"> <div className={'image-wrapper'}>
                                               <img src={post?.featuredImage?.node?.sourceUrl} alt={title} />
                                            </div></Link>
                                            <div>
                                                <Link href={'/blog/category/' + post.categories.nodes[0].slug + '/'}><div className={`category ${post.categories.nodes[0].slug}`} key={post.uri}>{post.categories.nodes[0].name}</div></Link>
                                                <div key={post.uri}>
                                                    <article
                                                        className="post-list-item"
                                                        itemScope
                                                        itemType="http://schema.org/Article"
                                                    >
                                                        <header>
                                                            <Link href={`/blog/${post.slug}`} itemProp="url"><h4>

                                                                {parse(title)}

                                                            </h4></Link>
                                                            <div className={"date-time"}>{dayjs(post?.date).format("D MMM YYYY")}</div>
                                                        </header>
                                                        {/*<section itemProp="description">{post.subTitle}</section>*/}
                                                    </article>
                                                </div>
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>

                <section className={'pagination'}>
                    <div className={'container'}>
                        <div className={'d-flex'}>
                            <div className={'pre'}>
                                {currentPage > 1 && (
                                    <>
                                        <Link href={prevPagePath}><button className={'primary'}>Previous page</button></Link>
                                        <br />
                                    </>
                                )}
                            </div>
                            <div className={'next'}>
                                {currentPage < totalPages && <Link href={nextPagePath}><button className={'primary'}>Next page</button></Link>}
                            </div>
                        </div>
                    </div>
                </section>

                <CallToActionSmall/>
            </div>
        </Layout>


    )
}

export default BlogArchive


